export const catalogued_departments: any = {
  'C-Suite': [
    'Executive',
    'Founder',
    'Finance Executive',
    'Human Resources Executive',
    'Information Technology Executive',
    'Legal Executive',
    'Marketing Executive',
    'Medical & Health Executive',
    'Operations Executive',
  ],
  Consulting: ['Consultant'],
  Design: ['All Design', 'Graphic / Visual / Brand Design', 'Product or UI/UX Design'],
  Education: ['Principal', 'Professor', 'Superintendent', 'Teacher'],
  'Engineering & Technical': [
    'Artificial Intelligence (AI) / Machine Learning',
    'Bioengineering',
    'Biometrics',
    'Business Intelligence',
    'Chemical Engineering',
    'Cloud / Mobility',
    'Data Science',
    'DevOps',
    'Emerging Technology/Innovation',
    'Engineering & Technical',
    'Industrial Engineering',
    'Mechanic',
    'Mobile Development',
    'Software Development',
    'Support / Technical Services',
    'Technician',
    'Technology Operations',
    'UI / UX',
    'Web Development',
    'Project Management',
    'Research & Development',
  ],
  Finance: [
    'Accounting',
    'Accounts Payable (AP)',
    'Accounts Receivable (AR)',
    'Finance',
    'Financial Planning & Analysis',
    'Financial Reporting',
    'Financial Risk',
    'Financial Strategy',
    'Financial Systems',
    'Internal Audit & Control',
    'Investor Relations',
    'Mergers & Acquisitions',
    'Real Estate Finance',
    'Shared Services',
    'Sourcing / Procurement',
    'Tax',
    'Treasury',
  ],
  'Human Resources': [
    'Compensation & Benefits',
    'Diversity & Inclusion',
    'Employee & Labor Relations',
    'Health & Safety',
    'HR Business Partner',
    'Human Resource Information System',
    'Human Resources',
    'Learning & Development',
    'Organizational Development',
    'Payroll',
    'People Operations',
    'Recruiting & Talent Acquisition',
    'Talent Management',
    'Workforce Management',
  ],
  'Information Technology': [
    'Application Development',
    'Business Service Management / ITSM',
    'Collaboration & Web Apps',
    'Data Center',
    'Data Warehouse',
    'Database Administration',
    'eCommerce Development',
    'Enterprise Architecture',
    'Help Desk / Desktop Services',
    'HR / Financial / ERP Systems',
    'Information Security',
    'Information Technology(IT)',
    'Infrastructure',
    'IT Asset Management',
    'IT Audit / IT Compliance',
    'IT Operations',
    'IT Procurement',
    'IT Strategy',
    'IT Training',
    'Networking',
    'Quality Assurance',
    'Retail / Store Systems',
    'Servers',
    'Storage & Disaster Recovery',
    'Telecommunications',
    'Virtualization',
  ],
  Legal: [
    'Acquisitions',
    'Compliance',
    'Contracts',
    'Corporate Secretary',
    'eDiscovery',
    'Ethics',
    'Governance',
    'Governmental Affairs & Regulatory Law',
    'Intellectual Property & Patent',
    'Labor & Employment',
    'Lawyer / Attorney',
    'Legal',
    'Legal Counsel',
    'Legal Operations',
    'Litigation',
    'Privacy',
  ],
  Marketing: [
    'Advertising',
    'Brand Management',
    'Content Marketing',
    'Customer Experience',
    'Customer Marketing',
    'Demand Generation',
    'Digital Marketing',
    'eCommerce',
    'Event Marketing',
    'Field Marketing',
    'Lead Generation',
    'Marketing',
    'Marketing Analytics / Insights',
    'Marketing Communications',
    'Marketing Operations',
    'Product Marketing',
    'Public Relations',
    'Search Engine Optimization (SEO) / Pay Per Click (PPC)',
    'Social Media Marketing',
    'Strategic Communications',
    'Technical Marketing',
  ],
  'Medical and Health': [
    'Anesthesiology',
    'Chiropractics',
    'Clinical Systems',
    'Dentistry',
    'Dermatology',
    'Doctors / Physicians',
    'Epidemiology',
    'First Responder',
    'Medical Education & Training',
    'Infectious Disease',
    'Medical Administration',
    'Social Work',
    'Medical Research',
    'Medicine',
    'Neurology',
    'Nursing',
    'Nutrition & Dietetics',
    'Obstetrics / Gynecology',
    'Oncology',
    'Ophthalmology',
    'Optometry',
    'Orthopedics',
    'Pathology',
    'Pediatrics',
    'Pharmacy',
    'Physical Therapy',
    'Psychiatry',
    'Public Health',
  ],
  Operations: [
    'Call Center',
    'Construction',
    'Corporate Strategy',
    'Enterprise Resource Planning',
    'Leasing',
    'Logistics',
    'Office Operations',
    'Operations',
    'Physical Security',
    'Project Development',
    'Quality Management',
    'Real Estate',
    'Safety',
    'Store Operations',
    'Supply Chain',
  ],
  Product: ['Product Development', 'Product Management'],
  Sales: [
    'Account Management',
    'Business Development',
    'Channel Sales',
    'Customer Success',
    'Inside Sales',
    'Partnerships',
    'Revenue Operations',
    'Sales',
    'Sales Enablement',
    'Sales Engineering',
    'Sales Operations',
    'Sales Training',
    'Field / Outside Sales',
  ],
};

export const parentDepartments = [
  'C-Suite',
  'Consulting',
  'Design',
  'Education',
  'Engineering & Technical',
  'Finance',
  'Human Resources',
  'Information Technology',
  'Legal',
  'Marketing',
  'Medical and Health',
  'Operations',
  'Product',
  'Sales',
];

export const cataloguedDepartmentsV2: any = {
  'General Management': [
    'Office of the CEO (CEO, President, Owner-operator, GM, Managing Director)',
    'Chief of Staff',
    'Corporate / Business Strategy',
    'General / Country / Regional Management',
    'General Management (Unspecified)',
  ],
  Sales: [
    'Account Executive / Direct Sales',
    'Sales Development (SDR / BDR)',
    'Field / Outside Sales',
    'Inside Sales',
    'Account Management',
    'Business Development',
    'Channel & Partner Sales',
    'Partnerships / Alliances',
    'Sales / Solutions Engineering (Pre-Sales)',
    'Sales Enablement',
    'Sales Training',
    'General Sales',
  ],
  Marketing: [
    'Brand & Creative',
    'Content Marketing',
    'Demand Generation / Growth',
    'Lead Generation',
    'Digital Marketing',
    'SEO / SEM / PPC',
    'Social Media Marketing',
    'Product Marketing',
    'Field & Event Marketing',
    'Customer / Lifecycle Marketing',
    'Communications / PR',
    'Marketing Analytics & Insights',
    'Advertising / Media',
    'Partner / Channel Marketing',
    'General Marketing',
    'eCommerce Marketing',
    'Technical Marketing',
  ],
  'Revenue Operations': [
    'Sales Operations',
    'Marketing Operations',
    'Customer Success Operations',
    'Revenue / GTM Operations (general)',
    'Deal Desk',
    'GTM Systems & Tools (CRM / MarTech admin)',
    'Revenue Analytics',
  ],
  'Customer Success & Support': [
    'Customer Success Management',
    'Customer Support / Service',
    'Technical Support / Technical Services',
    'Implementation / Onboarding',
    'Customer Experience (CX)',
    'Retention & Renewals',
    'Call Center / Contact Center',
    'General Customer Success & Support',
  ],
  Product: [
    'Product Management',
    'Product Development',
    'Product Operations',
    'Growth Product',
    'Technical Program / Product Program Management',
    'General Product',
  ],
  'Design / UX': [
    'Product Design / UI / UX',
    'Graphic / Visual / Brand Design',
    'UX Research',
    'Content / UX Writing',
    'Industrial / Hardware Design',
    'Motion / Multimedia Design',
    'General Design / UX',
  ],
  'Engineering / Software': [
    'Software Engineering / Development',
    'Frontend / Web Development',
    'Backend Development',
    'Mobile Development',
    'DevOps / Platform / SRE',
    'Cloud Engineering',
    'QA / Test / Quality Engineering',
    'Embedded / Firmware Engineering',
    'Engineering Management',
    'Scrum Master / Agile Coach',
    'Engineering Program Management',
    'Emerging Technology / Innovation',
    'Biometrics',
    'General Engineering / Software',
  ],
  'Data, Analytics & AI': [
    'Data Science',
    'Machine Learning / AI Engineering',
    'Data Engineering',
    'Analytics / Business Intelligence (BI)',
    'Analytics Engineering',
    'Data Architecture',
    'Data Governance / Quality',
    'Research Science (AI / applied research)',
    'General Data, Analytics & AI',
  ],
  'IT & Infrastructure': [
    'IT Operations',
    'Infrastructure / Systems',
    'Networking / Telecom',
    'Help Desk / Desktop Support',
    'Database Administration',
    'Cloud / Virtualization',
    'Enterprise Architecture',
    'Enterprise Applications / ERP / CRM Systems',
    'IT Service Management (ITSM)',
    'IT Strategy / IT Leadership',
    'IT Asset Management / IT Procurement',
    'Data Center / Storage / Disaster Recovery',
    'IT Audit / IT Compliance',
    'IT Training',
    'Retail / Store Systems',
    'General IT & Infrastructure',
  ],
  Security: [
    'Information Security / Cybersecurity',
    'Security Operations (SecOps / SOC)',
    'Application / Product Security',
    'Identity & Access Management',
    'Security Governance, Risk & Compliance',
    'Privacy / Data Protection',
    'Physical Security',
    'General Security',
  ],
  Finance: [
    'Accounting',
    'Accounts Payable (AP)',
    'Accounts Receivable (AR)',
    'Financial Planning & Analysis (FP&A)',
    'Financial Reporting / Controllership',
    'Treasury',
    'Tax',
    'Internal Audit & Controls',
    'Financial Risk',
    'Investor Relations',
    'M&A / Corporate Development',
    'Procurement / Sourcing',
    'Financial Systems',
    'General Finance',
    'Payroll',
    'Financial Strategy',
    'Shared Services',
    'Real Estate Finance',
  ],
  'Human Resources / People': [
    'HR / People Operations',
    'Recruiting / Talent Acquisition',
    'Talent Management',
    'Learning & Development',
    'Compensation & Benefits',
    'HR Business Partner',
    'HRIS / People Systems',
    'Diversity, Equity & Inclusion',
    'Employee & Labor Relations',
    'Organizational Development',
    'Workforce Management',
    'Health & Safety (EHS)',
    'General Human Resources / People',
  ],
  'Legal, Risk & Compliance': [
    'Legal Counsel / General Counsel',
    'General Legal, Risk & Compliance',
    'Corporate / Commercial Law',
    'Contracts',
    'Litigation',
    'Intellectual Property & Patent',
    'Compliance',
    'Governance / Corporate Secretary',
    'Regulatory & Government Affairs',
    'Privacy / Data Protection',
    'Labor & Employment Law',
    'Ethics',
    'Legal Operations',
    'eDiscovery',
    'Risk Management',
  ],
  Operations: [
    'Business Operations',
    'General Operations / Management',
    'Quality Management / Assurance (non-software)',
    'Facilities Management',
    'Project / Program Management (non-tech)',
    'Process / Continuous Improvement / Lean',
    'Manufacturing / Production',
    'Field / Service Operations',
    'Store / Retail Operations',
    'Safety / EHS',
    'Office Operations',
    'Project Development',
  ],
  'Supply Chain & Logistics': [
    'Supply Chain Management',
    'Logistics / Distribution',
    'Procurement / Purchasing',
    'Warehouse / Fulfillment',
    'Inventory / Demand Planning',
    'Transportation',
    'Sourcing / Vendor Management',
    'General Supply Chain & Logistics',
  ],
  'Medical & Health': [
    'Physicians / Doctors',
    'Nursing',
    'Surgery',
    'Clinical Operations',
    'Medical Administration',
    'Pharmacy',
    'Medical Research',
    'Allied Health / Therapy (Physical, Occupational, Speech)',
    'Mental Health (Psychiatry / Psychology)',
    'Dentistry',
    'Public Health / Epidemiology',
    'First Responder / EMS',
    'Nutrition & Dietetics',
    'Social Work',
    'Clinical Systems / Health IT',
    'Veterinary',
    'Medical Education & Training',
    'Anesthesiology',
    'Chiropractics',
    'Dermatology',
    'Infectious Disease',
    'Neurology',
    'Obstetrics / Gynecology',
    'Oncology',
    'Ophthalmology',
    'Optometry',
    'Orthopedics',
    'Pathology',
    'Pediatrics',
    'General Medical & Health',
  ],
  Education: [
    'Teaching / Faculty',
    'Professor / Academic',
    'School Administration (Principal, Superintendent)',
    'Academic Research',
    'Student Services / Counseling',
    'Curriculum / Instructional Design',
    'Education Technology',
    'General Education',
  ],
  'Consulting / Professional Services': [
    'Management / Strategy Consulting',
    'IT / Technology Consulting',
    'Implementation / Delivery',
    'Advisory',
    'General Consulting',
  ],
  'Research & Development / Science': [
    'R&D / Scientific Research',
    'Chemical Engineering',
    'Mechanical Engineering',
    'Electrical Engineering',
    'Civil Engineering',
    'Industrial Engineering',
    'Bioengineering / Biotech',
    'Clinical / Pharma R&D',
    'Innovation / Labs',
    'General Research & Development / Science',
  ],
  'Real Estate & Facilities': [
    'Real Estate Development',
    'Brokerage / Sales',
    'Property Management',
    'Leasing',
    'Facilities Management',
    'Construction',
    'Architecture',
    'General Real Estate & Facilities',
  ],
  'Skilled Trades & Field Services': [
    'Field / Maintenance Technician',
    'Mechanic',
    'Electrician / Lineman',
    'Plumbing / HVAC',
    'Driver / Delivery',
    'Installer',
    'Utility / Skilled Labor',
    'General Skilled Trades & Field Services',
  ],
};

export const parentDepartmentsV2 = Object.keys(cataloguedDepartmentsV2);

export const departmentsLabelsWithCommaV2 = [
  'Data, Analytics & AI',
  'Legal, Risk & Compliance',
  'Office of the CEO (CEO, President, Owner-operator, GM, Managing Director)',
  'Security Governance, Risk & Compliance',
  'Allied Health / Therapy (Physical, Occupational, Speech)',
  'School Administration (Principal, Superintendent)',
  'Diversity, Equity & Inclusion',
];

// Column values arrive as either a real array or a comma-joined string (some
// upstream paths stringify the array via `${row[field]}`). A naive `.split(',')`
// shreds V2 labels that contain their own commas (see departmentsLabelsWithCommaV2),
// so those labels are swapped for a placeholder before splitting and restored after.
const DEPT_COMMA_PLACEHOLDER = '\u0001';

export const splitDepartmentLabelsV2 = (value: unknown): string[] => {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value.map((item) => String(item ?? '').trim()).filter(Boolean);
  }
  if (typeof value !== 'string' || !value || value === 'N/A' || value === 'null') return [];

  let protectedValue = value;
  departmentsLabelsWithCommaV2.forEach((label) => {
    const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const placeholderLabel = label.split(',').join(DEPT_COMMA_PLACEHOLDER);
    protectedValue = protectedValue.replace(new RegExp(escaped, 'g'), placeholderLabel);
  });

  return protectedValue
    .split(',')
    .map((item) => item.split(DEPT_COMMA_PLACEHOLDER).join(',').trim())
    .filter(Boolean);
};
